import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/user.query.gql"
import type {
  UserQuery,
  UserQueryVariables,
} from "@/v2-backoffice-client/user/__types__/user.query"

type Options = QueryHookOptions<UserQuery, UserQueryVariables>

export function useUserQuery(options?: Options) {
  return useQuery<UserQuery, UserQueryVariables>(query, options)
}
